__turbopack_context__.v({
  "closeButton": "Dialog-module__gV8Hta__closeButton",
  "content": "Dialog-module__gV8Hta__content",
  "content-in": "Dialog-module__gV8Hta__content-in",
  "content-out": "Dialog-module__gV8Hta__content-out",
  "description": "Dialog-module__gV8Hta__description",
  "footer": "Dialog-module__gV8Hta__footer",
  "header": "Dialog-module__gV8Hta__header",
  "overlay": "Dialog-module__gV8Hta__overlay",
  "overlay-in": "Dialog-module__gV8Hta__overlay-in",
  "overlay-out": "Dialog-module__gV8Hta__overlay-out",
  "title": "Dialog-module__gV8Hta__title",
});
